import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { Row, Col } from 'src/componentes/grid';
import moment from 'moment';

export const NavbarDropdown = ({ children, count, showBadge, header, footer, onFooterClick, icon: Icon, className }) => (
  <UncontrolledDropdown className="nav-item mr-2">
    <DropdownToggle asChild>
      <a role="button" tabIndex={0} className={`nav-link nav-icon tw:cursor-pointer ${className || ''}`}>
        <div className="position-relative">
          <Icon className="align-middle" size={18} />
          {showBadge ? <span className="indicator">{count}</span> : null}
        </div>
      </a>
    </DropdownToggle>
    <DropdownMenu end className="tw:w-80 tw:p-0">
      <div className="dropdown-menu-header position-relative">
        {count} {header}
      </div>
      {children}
      <DropdownItem onClick={onFooterClick} className="tw:justify-center tw:text-muted-foreground">
        {footer}
      </DropdownItem>
    </DropdownMenu>
  </UncontrolledDropdown>
);

export const NavbarDropdownItem = ({ icon, title, description, time, spacing, ...rest }) => (
  <DropdownItem {...rest}>
    <Row className="gx-0 align-items-center tw:flex-1">
      <Col xs={2}>{icon}</Col>
      <Col xs={10} className={spacing ? 'pl-2' : null}>
        <div className="text-dark">{title}</div>
        <div className="text-muted small mt-1">{description}</div>
        {time && <div className="text-muted small mt-1">{moment(time).fromNow()}</div>}
      </Col>
    </Row>
  </DropdownItem>
);
